var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityDeepwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49935 2.68947V1.33301L7.49935 1.33301V2.68947C4.9529 2.92623 2.92591 4.95322 2.68914 7.49967H1.33203V8.49967H2.68914C2.92591 11.0461 4.9529 13.0731 7.49935 13.3099V14.6662H8.49935V13.3099C11.0458 13.0731 13.0728 11.0461 13.3096 8.49967H14.6654V7.49967H13.3096C13.0728 4.95322 11.0458 2.92623 8.49935 2.68947ZM7.49935 3.69488V4.33301H8.49935V3.69488C10.493 3.92393 12.0751 5.50601 12.3041 7.49967H11.6654V8.49967H12.3041C12.0751 10.4933 10.493 12.0754 8.49935 12.3045V11.6662H7.49935V12.3045C5.50568 12.0754 3.9236 10.4933 3.69455 8.49967H4.33203V7.49967H3.69455C3.9236 5.50601 5.50568 3.92393 7.49935 3.69488ZM9.99935 7.99967C9.99935 9.10424 9.10392 9.99967 7.99935 9.99967C6.89478 9.99967 5.99935 9.10424 5.99935 7.99967C5.99935 6.8951 6.89478 5.99967 7.99935 5.99967C9.10392 5.99967 9.99935 6.8951 9.99935 7.99967Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityDeepwork);
export default __webpack_public_path__ + "static/media/visibility-deepwork.557dedd4d3dbab8089f65582fd8af550.svg";
export { ForwardRef as ReactComponent };